import React from "react"
import "pages/Styles/UIKit_v2.sass"

type Props = {
    options: string[]
    selectedOption: string
    onSelectOption: (option: string) => void
}

function TabSelectorV2({ options, selectedOption, onSelectOption }: Props) {
    return (
        <div className="tab-selector-v2">
            <div className="tab-buttons-container">
                {options.map((option: string) => (
                    <button
                        key={option}
                        className={`new tab-button ${selectedOption === option ? 'active' : ''}`}
                        onClick={() => onSelectOption(option)}
                    >
                        <div className="tab-content">
                            <div className="tab-text">
                                {option}
                            </div>
                            <div className={`tab-indicator ${selectedOption === option ? 'active' : ''}`}></div>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    )
}

export default TabSelectorV2
